/** @format */
import { useRef, useState } from 'react';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';

const File = ({ field, onChangeValue, teamForm, setErrors }) => {
	const fileInput = useRef(null);
	const [file, setFile] = useState(
		field?.value === undefined || field?.value == null
			? undefined
			: field?.value,
	);
	const [loadIcon, setLoadIcon] = useState(true);
	const [fileIcon, setFileIcon] = useState('fas fa-folder-upload');
	const [loading, setLoading] = useState(false);

	const fileTypeIcon = async () => {
		setLoadIcon(false);
		let fileType = fileInput.current.files[0]?.type?.replace(
			/^([a-zA-Z]+)\//,
			'',
		);
		switch (fileType) {
			case 'zip':
				await setFileIcon('fas fa-file-archive');
				break;
			case 'rar':
				await setFileIcon('fas fa-file-archive');
				break;
			case 'mp4':
				await setFileIcon('fas fa-file-video');
				break;
			default:
				await setFileIcon('fas fa-not-equal');
				break;
		}

		setLoadIcon(true);
	};

	const onFileSelect = async () => {
		fileTypeIcon();
		if (
			field.validation.max_file_size &&
			fileInput.current.files[0]?.size !== undefined
		) {
			let fileSize = parseInt(fileInput.current.files[0]?.size) / 1000;
			if (fileSize > field.validation.max_file_size) {
				let errorMessage = {};
				errorMessage[
					field.name
				] = `حجم تصویر ارسالی نباید بیشتر از KB ${field.validation.max_file_size}  باشد`;
				setErrors(errorMessage);
				return;
			}
		}

		if (field?.validation?.mimes) {
			if (field?.validation?.mimes !== undefined) {
				let value = fileInput.current.files[0]?.type?.replace(
					/^([a-zA-Z]+)\//,
					'',
				);
				let mimes = field?.validation?.mimes?.split(',');
				let findMimes = mimes?.find((m) => m === value);
				if (!findMimes) {
					let errorMessage = {};
					errorMessage[
						field.name
					] = `فرمت فایل باید ${field.validation.mimes} باشد`;
					setErrors(errorMessage);
					return;
				}
			}
		}

		if (fileInput.current.files[0] === undefined) {
			fileInput.current.value = '';
			setFile(undefined);
		} else {
			setLoading(true);
			let url = `/upload/public/file`;
			await useApi.post(
				url,
				{ file: fileInput.current.files[0] },
				(res) => {
					onChangeValue(field.name, res.data.data.path, teamForm);
					setFile(res.data.data.url);
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					error('هنگام ثبت اطلاعات خطایی رخ داده است');
				},
				true,
			);
		}
		// tempSave({file: file, title: 'test file'});
	};
	return (
		<div className='form-group d-flex flex-column'>
			<label>{field.label}</label>
			{loading ? (
				<div
					style={{ width: '100px', height: '100px' }}
					className='bg-white img-thumbnail c-pointer d-flex flex-row justify-content-center align-items-center'>
					<div
						className='spinner-border spinner-border-sm text-secondary mb-1 mx-2'
						role='status'></div>
				</div>
			) : (
				<>
					<input
						type='file'
						className='d-none'
						ref={fileInput}
						id={`file-${field.id}`}
						onChange={() => onFileSelect()}
					/>
					<span
						onClick={() => {
							let input = document.getElementById(`file-${field.id}`);
							input.click();
						}}
						className='bg-white img-thumbnail c-pointer d-flex flex-column justify-content-center align-items-center'
						style={{ width: '100px', height: '100px' }}
						id={`file-icon-${field.id}`}>
						{loadIcon ? (
							<i className={`${fileIcon} f-40 text-dark`}></i>
						) : (
							<i className='fas fa-folder-upload f-40 text-dark'></i>
						)}
					</span>
				</>
			)}
		</div>
	);
};

export default File;
